(function () {
    var searchTerm, panelContainerId;
    // Create a new contains that is case insensitive
    $.expr[':'].containsCaseInsensitive = function (n, i, m) {
        return jQuery(n).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
    };
    const bardList_pro = [];
    $("#resultsArray_bard li.meta_item").each(function() {
        var model = $(this).text();
        item = {}
        item ["model"] = $.trim(model);
        bardList_pro.push(item);
    });
    //console.log(bardList_pro);

    const eubankList_pro = [];
    $("#resultsArray_eubank li.meta_item").each(function() {
        var model = $(this).text();
        item = {}
        item ["model"] = $.trim(model);
        eubankList_pro.push(item);
    });

    //console.log(eubankList_pro);
  
    const marvairList_pro = [];
    $("#resultsArray_marvair li.meta_item").each(function() {
        var model = $(this).text();
        item = {}
        item ["model"] = $.trim(model);
        marvairList_pro.push(item);
    });

    //console.log(marvairList_pro);
  
    $('#meta_search').on('blur', function(){
      var searchTerm = $(this).val();
      if(searchTerm == ''){
       $('.view_more_btn').show();
       $('.metaWrap_content .box_content').slideDown().removeClass('active');
       $('.metaWrap_content .box_content li').show();
      }
    }).on('focus', function(){
       $('.view_more_btn').hide();
       $('.metaWrap_content .box_content').addClass('active');
    });
    

    $('#meta_search').on('change keyup paste click', function () {
        searchTerm = $(this).val();
        if(searchTerm != ''){
          $('.clear_search').show();
        }else{
          $('.clear_search').hide();
          $('.metaWrap_content .box_content').slideDown();
          $('.metaWrap_content .box_content li').show();
          meta_count();
        }
        if (searchTerm.length < 3) {
          $('.metaWrap_content .box_content li').show();
            return;
        }
        searchAndDisplayProduct(searchTerm);
        
    });
    $('.clear_search').click(function(){
      $('#meta_search').val('').focus();
      //searchTerm = $('#meta_search').val();
      //searchAndDisplayProduct(searchTerm);
      $('.metaWrap_content .box_content').slideDown().removeClass('active');
      $('.metaWrap_content .box_content li').show();
      $('.view_more_btn').show();
      $(this).hide();
      meta_count();
    });
    

    function generateCombinations(model, searchValue) {
        const modelLower = model.toLowerCase();
        const searchLower = searchValue.toLowerCase();
        
        const combinations = [];
        function generate(currentModel, currentIndex) {
            if (currentIndex === currentModel.length) {
                combinations.push(currentModel);
                return;
            }
            if (currentModel[currentIndex] === '*') {
                for (let i = 0; i < searchLower.length; i++) {
                    const newModel = currentModel.slice(0, currentIndex) + searchLower[i] + currentModel.slice(currentIndex + 1);
                    generate(newModel, currentIndex + 1);
                }
            } else {
                generate(currentModel, currentIndex + 1);
            }
        }
        generate(modelLower, 0);
        return combinations;
    }
    
    function searchAndDisplayProduct(value) {
        const searchValue = value.toLowerCase();
    
        //document.querySelectorAll('.metaWrap_list').forEach(ul => ul.innerHTML = '');
    
        if (searchValue.length < 3) {
            return;
        }
    
        const resultsArray1 = checkParentModelMatchesProduct(bardList_pro, searchValue);
        displayResultsProduct('resultsArray_bard', resultsArray1);
    
        const resultsArray2 = checkParentModelMatchesProduct(eubankList_pro, searchValue);
        displayResultsProduct('resultsArray_eubank', resultsArray2);
    
        const resultsArray3 = checkParentModelMatchesProduct(marvairList_pro, searchValue);
        displayResultsProduct('resultsArray_marvair', resultsArray3);
    }
    
    function checkParentModelMatchesProduct(modelList, searchValue) {
        const matchedResults = [];
    
        modelList.forEach(item => {
            if (item.model.includes('*')) {
                const combinations = generateCombinations(item.model, searchValue);
    
                const isMatch = combinations.some(combo => combo.includes(searchValue));
    
                if (isMatch) {
                    matchedResults.push({
                        model: item.model
                    });
                }
            } else {
                if (item.model.toLowerCase().includes(searchValue)) {
                    matchedResults.push(item);
                }
            }
        });
    
        return matchedResults;
    }

    function displayResultsProduct(divId, results) {
      //$('#'+divId).slideDown();
      $('.view_more_btn').hide();
      $('.metaWrap_content .box_content').addClass('active');
      const resultsDiv = document.getElementById(divId).querySelector('.metaWrap_list');
      const ul = document.getElementById(divId).querySelector('.metaWrap_list');
      const liItems = ul.getElementsByTagName('li');
      
      if (results.length === 0) {
        //resultsDiv.innerHTML = '<p>No results found</p>';
        $('#'+divId).slideUp();
        const total_result = results.length;
        $('#'+divId).parent().find('.box_results').text(total_result + (total_result > 1 ? " results" : " result"));
        //console.log('Result id: '+divId)
        
      } else {
          const total_result = results.length;
          results.forEach(result => {
            /*
            const resultItem = document.createElement('li');
            resultItem.innerHTML = `${result.model}`;
            resultsDiv.appendChild(resultItem);*/
            for (let i = 0; i < liItems.length; i++) {
                const liText = liItems[i].textContent.toLowerCase();
                const isMatched = results.some(result => liText.includes(result.model.toLowerCase()));
    
                if (isMatched) {
                    liItems[i].style.display = 'list-item'; // Show matched items
                } else {
                    liItems[i].style.display = 'none'; // Hide non-matched items
                }
            }
            setTimeout(function(){
              $('#'+divId).slideDown();
              $('#'+divId).parent().find('.box_results').text(total_result + (total_result > 1 ? " results" : " result"));  
            },200)
            
            //console.log(divId)
          });
      }
    }
    
    function searchFaq(text){
      $('.metaWrap_list li').each(function () {
          //panelContainerId = '.' + $(this).attr('class');
          panelContainerId = '.' + $(this).attr('class');
          $(panelContainerId + ':not(:containsCaseInsensitive(' + text + '))').hide();
          $(panelContainerId + ':containsCaseInsensitive(' + text + ')').show();
      });
      var dagger = $('.metaWrap_list li:visible:contains("†")').length;
      console.log(dagger)
      if(dagger > 0){
        $('.meta_note').show();
      }else{
        $('.meta_note').hide();
      }
    }
  /*
    $('.clear_search').click(function(){
      $('#meta_search').val('').focus();
      searchTerm = $('#meta_search').val();
      searchFaq(searchTerm);
      meta_count();
      $('.metaWrap_content .box_content').removeClass('active');
      $('.view_more_btn').show();
      $(this).hide();
    });
    */
    function meta_count(){
      var bard_count = $('.bard_items li:visible').length;
      var marvair_count = $('.marvair_items li:visible').length;
      var eubank_count = $('.eubank_items li:visible').length;
      //console.log(bard_count)

      $('.bard_items .box_results').text(bard_count + (bard_count > 1 ? " results" : " result"));
      $('.marvair_items .box_results').text(marvair_count + (marvair_count > 1 ? " results" : " result"));
      $('.eubank_items .box_results').text(eubank_count + (eubank_count > 1 ? " results" : " result"));
    }
    meta_count();

    $(document).on('click', '.view_more_btn', function(){
        var $this = $(this);
        $this.closest('.box_content').toggleClass('active');
        var txt = $this.find('span').text();
        if (txt == "View all" ) {
            $this.find('span').text("Minimize");
        }else {
            $this.find('span').text("View all");
        }
    });
    
    /*  
    $('#model-lookup_search').on('change keyup paste click', function () {
        searchTerm = $(this).val();
        // server will only perform search with at least 3 characters
        if (searchTerm.length < 3) {
          $('.model-result_placeholder').slideDown();
          $('.model-results__wrap').slideUp();
            return;
        }
        searchModel(searchTerm);

        if(searchTerm != ''){
          $('.model-lookup_clear').show();
        }else{
          $('.model-lookup_clear').hide();
        }
    });
    */
    $('#model-lookup_search').on('change keyup paste click', function () {
        searchTerm = $(this).val();
        if(searchTerm != ''){
          $('.model-lookup_clear').show();
        }else{
          $('.model-lookup_clear').hide();
        }
        if (searchTerm.length < 3) {
          $('.model-result_placeholder').slideDown();
          $('.model-results__wrap').slideUp();
            return;
        }
        searchAndDisplay(searchTerm);
        setTimeout(function(){
          var getlen = $('.metaWrap_content:visible').length;
          //console.log(getlen);
          if(getlen){
            $('.model-results__head').show();
          }else{
            $('.model-results__head').hide();
            $('.model-lookup_noresult').slideDown();
          }
        },500)
        
        
    })
    $('.model-lookup_clear').click(function(){
      $('#model-lookup_search').val('').focus();
      $('.model-result_placeholder').slideDown();
      $('.model-results__wrap').slideUp();
      $(this).hide();
    });
    
    
    function generateCombinations(model, searchValue) {
        const modelLower = model.toLowerCase();
        const searchLower = searchValue.toLowerCase();
        
        const combinations = [];
    
        function generate(currentModel, currentIndex) {
            if (currentIndex === currentModel.length) {
                combinations.push(currentModel);
                return;
            }
    
            if (currentModel[currentIndex] === '*') {
                for (let i = 0; i < searchLower.length; i++) {
                    const newModel = currentModel.slice(0, currentIndex) + searchLower[i] + currentModel.slice(currentIndex + 1);
                    generate(newModel, currentIndex + 1);
                }
            } else {
                generate(currentModel, currentIndex + 1);
            }
        }
    
        generate(modelLower, 0);
    
        return combinations;
    }
    
    function searchAndDisplay(value) {
        const searchValue = value.toLowerCase();
    
        document.querySelectorAll('.metaWrap_list').forEach(ul => ul.innerHTML = '');
    
        if (searchValue.length < 3) {
            return;
        }
    
        const resultsArray1 = checkParentModelMatches(bard_list, searchValue);
        displayResults('resultsArray_bard', resultsArray1);
    
        const resultsArray2 = checkParentModelMatches(eubank_list, searchValue);
        displayResults('resultsArray_eubank', resultsArray2);
    
        const resultsArray3 = checkParentModelMatches(marvair_list, searchValue);
        displayResults('resultsArray_marvair', resultsArray3);
    }
    
    function checkParentModelMatches(modelList, searchValue) {
        const matchedResults = [];
    
        modelList.forEach(item => {
            if (item.model.includes('*')) {
                const combinations = generateCombinations(item.model, searchValue);
    
                const isMatch = combinations.some(combo => combo.includes(searchValue));
    
                if (isMatch) {
                    matchedResults.push({
                        model: item.model,
                        url: item.url
                    });
                }
            } else {
                if (item.model.toLowerCase().includes(searchValue)) {
                    matchedResults.push(item);
                }
            }
        });
    
        return matchedResults;
    }

    function displayResults(divId, results) {
      $('#'+divId).closest('.model-results__wrap').slideDown();
      const resultsDiv = document.getElementById(divId).querySelector('.metaWrap_list');
      
      if (results.length === 0) {
        //resultsDiv.innerHTML = '<p>No results found</p>';
        $('.model-result_placeholder').hide();
        $('#'+divId).closest('.metaWrap_content').slideUp();
        //console.log('Result id: '+divId)
        
      } else {
          const total_result = results.length;
          results.forEach(result => {
            const resultItem = document.createElement('li');
            resultItem.innerHTML = `<a href='https://hvacwallmount.com/products/${result.url}' title='${result.model}'>${result.model}</a>`;
            resultsDiv.appendChild(resultItem);
            $('#'+divId).closest('.metaWrap_content').slideDown();
            $('.model-result_placeholder').hide();
            $('.model-lookup_noresult').hide();
            $('.model-results__head').show();
            $('#'+divId).parent().find('.box_results').text(total_result + (total_result > 1 ? " results" : " result"))
            //console.log(divId)
          });
      }
    }
    
    
}());